import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '名称',
        placeholder: '',
        value: '',
        rules: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      },
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'level',
        fieldName: '紧急程度',
        placeholder: '紧急程度系数，数字越大，越紧急',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      },
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'maxCompletedDays',
        fieldName: '最大完成天数',
        placeholder: '最大完成天数',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }
    ]
  }
]
